import React, { Component } from 'react';
import SearchForm from '../views/GuaranteeCharge/SearchForm';

class GuaranteeCharge extends Component {
  render() {
    return (
      <div className='guarantee-charge'>
        <SearchForm />
      </div>
    );
  }
}

export default GuaranteeCharge;
